<template>
  <div class="modal-card">
    <header class="modal-card-head has-text-centered">
      <div class="rating-banner">
        <rating-banner class="svg-icon"></rating-banner>
      </div>
      <button class="delete" type="button" @click="$parent.close"></button>
    </header>
    <section class="modal-card-body pt-1">
      <div v-if="!currentResponses">
        <b-loading :active="true"></b-loading>
      </div>
      <div v-else v-for="(item, index) in ratings" :key="index" class="has-fullwidth mb-4">
        <component
          :is="getComponentForQuestion(item)"
          :current-response="getCurrentResponses(item)"
          :rating="item"
          @input="input"
        ></component>
      </div>
      <div>
        <button class="button is-fullwidth is-primary mb-2 mt-2" @click="sendResponses">
          {{ $t("common.send") }}
        </button>
      </div>
    </section>
    <footer class="modal-card-foot"></footer>
  </div>
</template>

<script>
import CloseIcon from "@/assets/icon_close.svg";
import RatingBanner from "@/assets/rating/rating_banner.svg";
import Constants from "@/widgets/shared/constants";
import SessionRatingClosedQuestion from "@/widgets/agenda/components/rating/SessionRatingClosedQuestion";
import SessionRatingOpenQuestion from "@/widgets/agenda/components/rating/SessionRatingOpenQuestion";
import SessionRatingStarsQuestion from "@/widgets/agenda/components/rating/SessionRatingStarsQuestion";
import Footer from "@/shared/components/Footer";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "AgendaSessionRatingModal",

  components: {Footer, CloseIcon, RatingBanner},

  props: {
    ratings: {
      type: Array,
      required: true,
    },

    agendaSessionId: {
      type: Number,
      required: true,
    },

    componentId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      responses: {},
    };
  },

  computed: {
    ...mapGetters("agendaSessionRatings", ["getMyRating", "getIsLoadingMyRating"]),

    currentResponses() {
      return this.getMyRating(this.agendaSessionId);
    },

    isLoading() {
      return this.getIsLoadingMyRating(this.agendaSessionId);
    },
  },

  methods: {
    ...mapActions("agendaSessionRatings", ["sendRating", "fetchMyRating"]),

    getComponentForQuestion(question) {
      if (question.rating_type === Constants.AGENDA_SESSION_RATING_TYPES.CLOSED) {
        return SessionRatingClosedQuestion;
      } else if (question.rating_type === Constants.AGENDA_SESSION_RATING_TYPES.STARS) {
        return SessionRatingStarsQuestion;
      } else if (question.rating_type === Constants.AGENDA_SESSION_RATING_TYPES.OPEN) {
        return SessionRatingOpenQuestion;
      } else {
        throw Error("Error: unknown rating_type");
      }
    },

    getCurrentResponses(question) {
      if (this.currentResponses && this.currentResponses.length) {
        const response = this.currentResponses.find(response => response.agenda_session_rating_id === question.id);
        if (response) {
          if (question.rating_type === Constants.AGENDA_SESSION_RATING_TYPES.OPEN) {
            return response.open_question_response;
          } else {
            return response.agenda_session_answer_ids;
          }
        } else {
          return null;
        }
      } else {
        return null;
      }
    },

    input(event) {
      const {ratingId, responses, type} = event;
      this.responses[ratingId] = {type, responses};
    },

    sendResponses() {
      this.sendRating({
        componentId: this.componentId,
        agendaSessionId: this.agendaSessionId,
        responses: this.responses,
      }).then(result => {
        this.$parent.close();
      });
    },
  },

  watch: {
    ratings: {
      immediate: true,
      handler: function (newValue) {
        if (!newValue.length) {
          this.$parent.close();
        }
      },
    },
  },

  mounted() {
    this.fetchMyRating({componentId: this.componentId, agendaSessionId: this.agendaSessionId});
  },
};
</script>

<style scoped lang="scss">
.rating-banner {
  height: 200px;
}

.close-button {
  width: 26px;
  height: 26px;
  cursor: pointer;
  border-radius: 50%;
  background: #e0e0e0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 7px;
  position: absolute;
  right: 30px;

  .close-icon {
    fill: #333333;
    width: 100%;
    height: 100%;
  }
}

.modal-card-foot {
  height: 6px !important;
  padding: 0;
}
</style>
